import Vue from 'vue'
import Component from 'vue-class-component'
import { Store } from 'vuex'
import RootState from '../../store/state'
import TimerVue from '../notifications/Timer.vue'
import { ErrorStatus } from '../../store/common/state'

@Component({
  components: {
    'timer-vue': TimerVue
  },
  props: {
    errorData: {
      type: String,
      required: true
    }
  }
})
export default class RedirectToLoginModal extends Vue {
  name: 'RedirectToLoginModal'
  $store: Store<RootState>
  readonly aquariumLoginUrl: string = process.env.AQUARIUM_LOGIN_URL
  readonly errorData: ErrorStatus
  message: string = ''
  subMessage: string = ''
  timer: number = 30

  redirectToLogin(): void {
    window.location.href = this.aquariumLoginUrl
  }

  created(): void {
    this.message = '通信中にエラーが発生しました。'
    this.subMessage = '通信環境をご確認のうえ、時間をおいて再度アクセスしてください。'
    this.timer = 30

    if (this.errorData === 'session-timeout') {
      this.message = '認証の有効期限が切れました。'
      this.subMessage = ''
      this.timer = 20
    }

    if (this.errorData === 'not-found') {
      this.message = 'ページが存在しません。'
      this.subMessage = ''
      this.timer = 20
    }

  }
}
